module.exports = __webpack_public_path__ + "img/128.645343d1.jpg";